import { analysisNames } from "./analysisHelper";
import buffer from "./buffer";
import tyson from "./tyson";
import intersect from "./intersect";
import union from "./union";
import tin from "./tin";

const analysis = {
    buffer: buffer,
    tyson: tyson,
    intersect: intersect,
    union: union,
    tin: tin
};

export { analysis, analysisNames };